import { Component, Input } from "@angular/core";
import { OrganizationType } from "../../types/app.step.type";
import { MatListModule } from '@angular/material/list';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { AuthService } from "../../services/auth.service";
import { finalize } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { showSnackBar } from "../../utils/snackBar.ulti";
import { LoadingComponent } from "../loading/loading.component";
import { NgIf } from "@angular/common";
import { PAGE_ROUTES, SESSION_KEY_NAME } from "../../constants";
import { Router } from "@angular/router";

@Component({
  selector: "app-oganizations-selection",
  imports: [MatListModule, MatIconModule, TranslatePipe, LoadingComponent, NgIf],
  standalone: true,
  templateUrl: "./organizations-selection.component.html",
  styleUrl: "./organizations-selection.component.scss"
})
export class OrganizationsSelectionComponent {
  @Input() pendingToken = "";
  @Input() redirectUri = "";
  @Input() organizations: OrganizationType[] = [];

  protected isLoading = false

  constructor(
    private _authService: AuthService,
    private _snackBar: MatSnackBar,
    private _translate: TranslateService,
    private _router: Router
  ) { }

  onSelect(org: OrganizationType) {
    this.isLoading = true

    this._authService
      .loginOrganizationsSelection({ pending_authentication_token: this.pendingToken as string, organization_id: org.id })
      .pipe(finalize(() => {
        this.isLoading = false
      }))
      .subscribe({
        next: (result) => {
          // Store the session email and session_id for authenticate success with pending_authentication_token
          localStorage.setItem(SESSION_KEY_NAME.WORKOS.previous_session_login_hint, result.login_hint as string)
          localStorage.setItem(SESSION_KEY_NAME.WORKOS.session_id, result.session_id as string)

          const queryParams = { accessToken: result.access_token as string, redirectUri: this.redirectUri as string, sessionId: result.session_id as string }

          // Redirect to susscess page
          this._router.navigate([PAGE_ROUTES.SUCCESS], { queryParams })
        },
        error: (err) => {
          if (err.error.message)
            showSnackBar({ type: 'error', message: err.error.message, snackBar: this._snackBar, translate: this._translate })
        }
      })
  }
}
